import { Component, OnInit } from '@angular/core';

import { apiService } from '../../../../service/api.service'
@Component({
  selector: 'app-cronograma',
  templateUrl: './cronograma.component.html',
  styleUrls: ['./cronograma.component.css']
})
export class CronogramaComponent implements OnInit {
  etapaJardin = 0;
  constructor(
    private api: apiService,
  ) { }

  ngOnInit(): void {
    this.etapaJardin = this.api.dataJardin.etapaJardin;
  }

}
